/*
* Pipeline Theme — UltraViolet Sports
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

(function() {

  // ============================================================
  // RECHERCHE PRÉDICTIVE — Inclusion des SKU dans les résultats
  // ============================================================
  (function interceptPredictiveSearchFetch() {
    const originalFetch = window.fetch;

    window.fetch = function(resource, init) {
      let url = typeof resource === 'string' ? resource
              : (resource instanceof Request ? resource.url : null);

      if (url && (url.includes('/search/suggest') || url.includes('predictive_search'))) {
        try {
          const urlObj = new URL(url, window.location.origin);
          if (!urlObj.searchParams.has('resources[fields]')) {
            urlObj.searchParams.set('resources[fields]', 'title,product_type,variants.title,variants.sku,vendor,tag');
            urlObj.searchParams.set('resources[limit]', '6');
          }

          if (typeof resource === 'string') {
            resource = urlObj.pathname + urlObj.search;
          } else if (resource instanceof Request) {
            resource = new Request(urlObj.pathname + urlObj.search, resource);
          }
        } catch (e) {
          console.warn('[UV Search] Erreur:', e);
        }
      }

      return originalFetch.call(this, resource, init);
    };
  })();


})();